import React from 'react';
import { Button, Spinner } from 'reactstrap';
import FeatherIcon from 'feather-icons-react';
import { useTranslation } from 'react-i18next';

/**
 * Slim strip that surfaces an import the user has left open.
 *
 * A commit keeps running on the server after the tab is closed, and a preview waits a day for a
 * decision. Without this the work would simply vanish from view: the user would close the tab
 * mid-import, come back, see nothing, and upload the same file again.
 *
 * @param {object} props
 * @param {object|null} props.job the open import job, if any
 * @param {function} props.onResume opens the import dialog on the job
 */
const ImportResumeBanner = ({ job, onResume }) => {
    const { t } = useTranslation();

    if (!job || !['VALIDATING', 'READY', 'COMMITTING'].includes(job.status)) {
        return null;
    }

    const running = job.status !== 'READY';
    return (
        <div className="alert alert-info d-flex align-items-center justify-content-between py-2 mb-3">
            <div className="d-flex align-items-center">
                {running
                    ? <Spinner size="sm" className="me-2" />
                    : <FeatherIcon icon="clock" size={16} className="me-2" />}
                <span style={{ fontSize: '14px' }}>
                    {running
                        ? t('business.import_job.banner_running', 'An import is in progress.')
                        : t('business.import_job.banner_ready',
                            'An import is waiting for your confirmation: {{create}} to create, {{update}} to update.',
                            { create: job.createRows || 0, update: job.updateRows || 0 })}
                </span>
            </div>
            <Button color="info" size="sm" onClick={onResume}>
                {t('business.import_job.resume', 'Resume')}
            </Button>
        </div>
    );
};

export default ImportResumeBanner;
